<template>
  <div>
    <div class="header_h5">
      <div class="logo_h5" @click="openHome">
        <img src="@/assets/images/h5/logo.png" alt="" />
      </div>
      <!-- 右边的登录模块 -->
      <div class="logo_h5-right">
        <!-- 充值 -->
        <div
          :class="$area !== 'komoe-sea' ? 'recharge xianyou' : 'recharge'"
          @click="openPay"
          v-if="navFlags.is_show_invest"
        >
          <img
            v-if="checkRouter(routeNames) < 0"
            src="@/assets/images/h5/icon9.png"
            alt=""
          />
          <img
            v-if="checkRouter(routeNames) >= 0"
            src="@/assets/images/h5/icon10.png"
            alt=""
          />
          <p :class="checkRouter(routeNames) >= 0 ? 'pcolor' : ''">
            {{ $t("header.pay") }}
          </p>
        </div>
        <!-- 语言切换 -->
        <div class="langchange" ref="containers" v-if="$area === 'komoe-sea'">
          <div class="langchange-one" @click="langState = !langState">
            <img src="@/assets/images/h5/icon11.png" alt="" />
            <p>{{ langDes }}</p>
          </div>
          <transition name="fade">
            <div v-if="langState" class="langchange-two">
              <div
                v-for="(item, index) in languages"
                :key="index"
                :class="item.label == langDes ? 'actives' : ''"
              >
                <a href="javascript:;" @click="switchLang(item)">
                  {{ item.label }}
                </a>
              </div>
            </div>
          </transition>
        </div>
        <!-- 没有登录 -->
        <div
          v-if="!loginInfo.mid && $area !== 'komoe'"
          class="login_btn"
          @click="goLogin"
        >
          {{ $t("header.login") }}
        </div>
        <!-- 登录成功后 -->
        <div v-if="loginInfo.mid" class="user_btn" @click="toggleLogout(true)">
          <img src="./img/noface.svg" alt="" />
        </div>
      </div>
    </div>
    <!-- 退出登录弹框组件 -->
    <pop-window :title="$t('header.confirmToLogout')" ref="logout">
      <div class="signout">
        <div class="block_btn border_btn" @click="toggleLogout(false)">
          {{ $t("header.cancel") }}
        </div>

        <div class="block_btn fill_btn" @click="goLogout">
          {{ $t("header.logout") }}
        </div>
      </div>
    </pop-window>
  </div>
</template>

<script>
import popWindow from "@/component/popWindow/index.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "header-h5",
  // props: [
  //     'guest'
  // ],
  components: {
    popWindow,
  },
  computed: {
    ...mapGetters(["globalLang", "languages", "userInfo", "userType"]),
    langDes() {
      return this.languages.find((lang) => lang.lang === this.globalLang).label;
    },
  },
  data() {
    return {
      loginInfo: {},
      langState: false,
      routeNames: "",
      navFlags: {
        is_show_cs: 0,
        is_show_fans_group: 0,
        is_show_game: 0,
        is_show_invest: 0,
        is_show_news: 0,
      },
    };
  },
  watch: {
    $route: {
      handler: function(val) {
        this.routeNames = val.name;
      },
    },
  },
  created() {
    this.$apis.header
      .getNavList()
      .then((res) => {
        if (res.data.code == 0) {
          this.navFlags = Object.assign({}, res.data.data);
        } else {
          // 接口请求失败时展示客服
          this.navFlags.is_show_cs = 1;
        }
      })
      .catch(() => {
        // 接口请求失败时展示客服
        this.navFlags.is_show_cs = 1;
      });
  },
  mounted() {
    window.addEventListener("click", this.otherCloses);
    this.getLoginInfo();
  },
  methods: {
    checkRouter(name) {
      return name.indexOf("pay");
    },
    otherCloses(e) {
      if (this.$area !== "komoe-sea") return;
      if (!this.$refs.containers.contains(e.target)) this.langState = false;
    },
    openHome() {
      if (this.$route.name == "homeH5") return;
      this.$router.push({ path: "/h5" });
    },
    openPay() {
      if (this.$route.name == "pay_h5" || this.$route.name == "pays_h5") return;
      if (this.$utils.getDomainName("www.komoejoy.com")) {
        this.$router.push({ path: "/pays_h5" });
      } else {
        this.$router.push({ path: "/pay_h5" });
      }
    },
    ...mapActions({
      setLang: "setGlobalLang",
    }),
    switchLang(lang) {
      if (lang.lang === this.globalLang) {
        return;
      }
      this.langState = false;
      this.setLang(lang.lang);
      window.location.reload();
    },
    // 发请求
    getLoginInfo() {
      this.$apis.header
        .getUserInfo(this.$utils.token("joy_jct"))
        .then((res) => {
          if (res.data.code === 0) {
            this.loginInfo = res.data.data;
          } else {
            // if (!this.guest) {
            //     this.goLogin();
            // }
            this.loginInfo = {};
          }
        });
    },
    // 去登陆页
    goLogin() {
      if (location.pathname === "/login_h5") {
        return false;
      } else {
        this.$router.push({
          path: "/login_h5",
          query: {
            redirect: location.href,
          },
        });
      }
    },
    goLogout() {
      const logout =
        this.$area === "komoe-sea"
          ? this.$apis.common.logOut
          : this.$apis.header.userLogout;
      logout(this.$utils.token("joy_jct")).then((res) => {
        if (res.data.code == 0) {
          this.loginInfo = {};
          this.toggleLogout(false);
          // if (!this.guest) {
          //     this.goLogin();
          // }
          // 客服需要登录页面，退出登录需要返回常见问题页面
          const routes = [
            "/service/h5/question",
            "/service/h5/history",
            "/service/h5/info",
            "/service/h5/order_detail",
            "/service/h5/requestion",
          ];
          const routeslist = [
            "/pay_h5/pg_record",
            "/pay_h5/setoutpay",
            "/pay_h5/payorder",
            "/pay_h5/paycomplete",
            "/pay_h5/paysucceed",
            "/pay_h5/payaffirm",
            "/pays_h5/pg_record",
            "/pays_h5/setoutpay",
            "/pays_h5/payorder",
            "/pays_h5/paycomplete",
            "/pays_h5/paysucceed",
            "/pays_h5/payaffirm",
          ];
          if (routes.indexOf(this.$route.path) > -1) {
            this.$router.push("/service/h5");
          }
          if (routeslist.indexOf(this.$route.path) > -1) {
            if (this.$utils.getDomainName("www.komoejoy.com")) {
              this.$router.push("/pays_h5");
            } else {
              this.$router.push("/pay_h5");
            }
          }
        } else {
          alert(res.data.message || this.$t("header.netError"));
        }
      });
    },
    toggleLogout(boo) {
      this.$refs.logout.poptoggle(boo);
    },
  },
  beforeDestroy() {
    /* 组件销毁的时候要移除侦听器 */
    window.removeEventListener("click", this.otherCloses);
  },
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.7s;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
$cl_green: #50bbe5;
$cl_dark: #444444;

.header_h5 {
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  // transform: translateX(-50%);
  width: 100%;
  // max-width: 540px;
  box-sizing: border-box;
  height: 0.48rem;
  padding: 0 0.12rem;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.1);
  .logo_h5 {
    // margin-top: 0.1rem;
    img {
      display: block;
      width: 1.07rem;
      height: 0.13rem;
    }
  }
  .logo_h5-right {
    width: auto;
    height: 100%;
    display: flex;
    align-items: center;

    .recharge {
      width: 0.8rem;
      height: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      p {
        margin-left: 0.05rem;
        font-size: 0.12rem;
        font-family: SourceHanSansCN;
        font-weight: bold;
        color: #444444;
        &.pcolor {
          color: $cl_green;
        }
      }
      img {
        width: 0.13rem;
        height: 0.13rem;
      }
    }
    .xianyou {
      margin-right: 0.2rem;
    }
    .langchange {
      width: 1rem;
      height: 100%;
      position: relative;
      &-one {
        width: 1rem;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 0.13rem;
          height: 0.13rem;
        }
        p {
          margin-left: 0.05rem;
          font-size: 0.12rem;
          font-family: SourceHanSansCN;
          font-weight: bold;
          color: #444444;
        }
      }
      &-two {
        z-index: 1;
        position: absolute;
        top: 0;
        width: 100%;
        height: 2.4rem;
        background: white;
        margin-top: 0.48rem;
        div {
          width: 100%;
          height: 0.48rem;
          display: flex;
          align-items: center;
          justify-content: center;
          a {
            font-size: 12px;
            font-family: SourceHanSansCN;
            font-weight: bold;
            color: #444444;
          }
          &.actives {
            a {
              color: $cl_green;
            }
          }
        }
      }
    }
    .login_btn {
      // margin-top: 0.14rem;
      width: auto;
      min-width: 0.4rem;
      height: 0.2rem;
      background: $cl_green;
      color: white;
      text-align: center;
      border-radius: 0.1rem;
      font-size: 0.1rem;
      line-height: 0.2rem;
      cursor: pointer;
    }
    .user_btn {
      border: 2px solid #14b0f6;
      cursor: pointer;
      border-radius: 50%;
      overflow: hidden;
      img {
        display: block;
        width: 0.28rem;
      }
    }
  }
}

.signout {
  .block_btn {
    margin: 0.4rem 0;
  }
}
</style>
